// extracted by mini-css-extract-plugin
export var button = "edit-address-form-module--button--cf8fe";
export var buttonWrapper = "edit-address-form-module--buttonWrapper--db874";
export var closeButton = "edit-address-form-module--closeButton--7da05";
export var form = "edit-address-form-module--form--bb9b7";
export var formItem = "edit-address-form-module--formItem--7e4ef";
export var formWrapper = "edit-address-form-module--formWrapper--5302e";
export var title = "edit-address-form-module--title--013e9";